export type TradeDirection = 'buy' | 'sell';

export enum ETradeDirection {
  buy = 'buy',
  sell = 'sell',
}
